/**
 * 화면 권한 표시 can()·canAny() — 계약 PERMISSIONS 7 「화면 can()」. perms = introspect `profile.perms`.
 * perms 칸이 없으면(옛 inapi·W2 합류 전) 숨기지 않고 서버 판정에 맡긴다(W6 2-2).
 * 운영자 ● 코드(ops.support.*·ops.security.manage·ops.audit.* 등)는 배포일부터 서버가 막으므로 log 기간과 상관없이 이것으로 숨긴다.
 */
export const permsOf = (introspect) =>
  Array.isArray(introspect?.profile?.perms) ? introspect.profile.perms : null;

export const can = (perms, code) => !Array.isArray(perms) || perms.includes(code);

/**
 * 화면이 저절로 부르는 서버 경로용: introspect 를 받기 전(store 값 null)엔 아직 모름 → false.
 * 받은 뒤엔 can() 그대로(perms 칸이 없으면 숨기지 않음). 운영자 ● 코드 경로를 읽기 전에 불러 403 알림이 뜨던 것(10-30).
 */
export const canNow = (introspect, code) => introspect != null && can(permsOf(introspect), code);

export const canAny = (perms, codes = []) =>
  !Array.isArray(perms) || codes.some((c) => perms.includes(c));

/**
 * 새 권한으로 숨기는 메뉴 → 보이는 코드(하나라도 있으면 보임). 메뉴 v-if 와 라우터 가드(meta.menu)가 같이 쓴다(REDIRECT-REQ 1).
 * 운영자 ● 코드라 log 기간에도 이것으로 숨기고 막는다(서버가 배포일부터 막음).
 */
export const MENU_PERMS = {
  permObservations: ["ops.security.manage"],
  auditLogs: ["ops.audit.view", "ops.support.edit"], // 전체 조회 또는 내 지원 기록
  auditChecks: ["ops.audit.view"],
};

/** 메뉴(또는 그 주소)를 볼 수 있나. 표에 없는 메뉴·perms 칸이 없으면(옛 inapi·introspect 실패) 막지 않음 */
export const canMenu = (perms, menuKey) => !MENU_PERMS[menuKey] || canAny(perms, MENU_PERMS[menuKey]);

/** 권한 이름표가 있는 앱(inapi 카탈로그 apps — GET /perm-catalog?app= 은 이 중 하나만 받음) */
export const PERM_APPS = ["studio", "admin-hospital", "admin-manufacturer", "admin-certilife", "admin-reseller"];

/** GET /perm-catalog 응답 여러 개({codes:[{code, ko}]} | null) → {code: ko}. 못 받은 앱(null)은 건너뜀 */
export const mergePermLabels = (catalogs = []) => {
  const labels = {};
  catalogs.forEach((data) =>
    (data?.codes || []).forEach((c) => {
      if (c && c.code && c.ko) labels[c.code] = c.ko;
    })
  );
  return labels;
};
